import { render, staticRenderFns } from "./Riskprofile.vue?vue&type=template&id=cd2407bc&"
import script from "./Riskprofile.vue?vue&type=script&lang=js&"
export * from "./Riskprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports